// The provenance seal — the product's signature element. Every explanation is
// anchored to a specific validated claim from theuth, and this component makes
// that anchor visible: the claim id, the underlying statement, and the full
// provenance chain (source / author / curation program / validation status).
//
// This is deliberately the most distinctive thing on screen. It is the visual
// argument that the answer is not model-confabulated but drawn from a curated,
// attributable corpus.

function statusClass(status) {
  const s = String(status).toLowerCase();
  if (s.includes('valid') || s.includes('approved') || s.includes('certified')) {
    return 'badge badge-validated';
  }
  if (s.includes('pending') || s.includes('review')) return 'badge badge-pending';
  return 'badge';
}

export default function ProvenanceSeal({ claim }) {
  const { provenance } = claim;
  return (
    <div className="seal">
      <div className="seal-head">
        <span className="seal-label">Validated knowledge</span>
        <span className={statusClass(provenance.validationStatus)}>
          {provenance.validationStatus}
        </span>
      </div>

      <p style={{ margin: '0 0 0.6rem', fontSize: '0.9rem', lineHeight: 1.55 }}>
        {claim.statement}
      </p>

      <dl className="seal-grid">
        <dt>Claim</dt>
        <dd className="seal-claimid">{claim.claimId}</dd>

        <dt>System</dt>
        <dd>{claim.system}</dd>

        <dt>Source</dt>
        <dd>{provenance.source}</dd>

        <dt>Author</dt>
        <dd>{provenance.author}</dd>

        <dt>Program</dt>
        <dd>{provenance.curationProgram}</dd>
      </dl>
    </div>
  );
}
